<template>
  <div class="modal-wrapper">
    <BasicModal
      :title="title"
      :isShowModal=isShowModal
      :canCancel="true"
      @cancel="cancel">
      <article class="container">
        <!-- 会話済みロボ一覧 -->
        <section class="main-section" v-if="isLoading === false && messageList.length !== 0">
          <article class="table-wrapper">
            <!-- テーブル一覧 -->
            <MessageListTable v-if="isClickDetailButton === false"
              :messageList="messageList"
              @clickDetailButton="clickDetailButton"/>
            <!-- 会話詳細 -->
            <MessageDetail v-if="isClickDetailButton"
              :selectMessage="selectMessage"
              @clickCloseBtn="clickCloseBtn"/>
          </article>
        </section>

        <!-- 会話済みロボ一覧 会話がない場合 -->
        <section v-if="isLoading === false && messageList.length === 0">
          <p>この応募者はまだロボと会話していません。</p>
        </section>
      </article>
    </BasicModal>
  </div>
</template>

<script>
import BasicModal from '@/components/Modals/BasicModal'
import MessageListTable from '@/components/molecules/tables/MessageListTable'
import MessageDetail from '@/components/organisms/articles/MessageDetail'
import { mapState }       from 'vuex'

export default {
  components: {
    BasicModal,
    MessageListTable,
    MessageDetail
  },
  props: {
    isShowModal: {
      type: Boolean,
      required: false,
      default: false
    },
    selectSeeker: {
      type: Object,
      required: false
    },
    messageList: {
      type: Array
    }
  },
  computed: {
    ...mapState('directtalk', ['chatLogsLoading'])
  },
  data () {
    return {
      isClickDetailButton: false,
      isLoading: false,
      selectMessage: [
        'createdAt',        
        'createdAtOther',
        'email',
        'filename',
        'files',
        'icon',
        'id',
        'isBot',
        'isManager',
        'message',
        'name',
        'parameter',
        'speaker',
        'status'
      ],
      sortMessageList: [],
      title: ""
    }
  }, 
  methods: {
    cancel () {
      this.$emit('cancel', false)
      this.isClickDetailButton = false
    },
    clickDetailButton (sended) {      
      this.sortMessageList = this.messageList.sort((a,b) => {
        return (a.createdAt < b.createdAt) ? -1 : (a.createdAt > b.createdAt) ? 1 : 0;
      })

      const prevRoboName = sended.name;
      let isSameFlag = false;
      const mes = [];

      this.sortMessageList.forEach(function (message) {
        if (message.speaker === "my" && prevRoboName === message.name) {
          isSameFlag = true;
          } else if (message.speaker === "my" && prevRoboName !== message.name) {
            isSameFlag = false;
          };

        if (isSameFlag === true) {
          mes.push(message);
        };
      });

      this.selectMessage = mes
      this.isClickDetailButton = true
      this.title = '会話ロボ名（' +  prevRoboName + '）'
    },
    clickCloseBtn () {
      this.isClickDetailButton = false
      this.title = 'ロボ会話一覧（' +  this.selectSeeker.name + '）'
    }
  },
  watch:{
    chatLogsLoading () {
      this.isLoading = this.chatLogsLoading
      this.title = 'ロボ会話一覧（' +  this.selectSeeker.name + '）'
    }
  }
}
</script>

<style lang="scss" scoped>
.modal-wrapper {
  .container {
    padding: 8px;
    height: 600px;
    display: flex;
    align-items: center;
    overflow: auto;
    section {
      width: 100%;
    }
  }
  .button-wrapper {
    margin-top: 16px;
  }
  .table-wrapper {
    display: flex;
    justify-content: center;
    height: 100%;
    position: relative;
    padding: 8px;
  }
  .main-section {
    height: 100%;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/organisms/modals/ModalMessageList.vue